import { Step } from "react-joyride";

export const getPlanTourSteps = (): Step[] => [
  {
    target: 'h1',
    content: 'Aquí puedes ver el nombre y descripción del plan de entrenamiento.',
    placement: 'bottom',
  },
  {
    target: 'button[type="button"]',
    content: 'Crea o selecciona una nueva rutina para agregar al plan.',
    placement: 'bottom',
  },
  {
    target: '.inline-flex.h-10.items-center.justify-start.p-1.w-auto.bg-transparent.space-x-1',
    content: 'Navega entre las diferentes rutinas usando estos botones.',
    placement: 'top',
  },
  {
    target: '.plan-st',
    content: 'Aquí verás todos los ejercicios de la rutina seleccionada.',
    placement: 'top',
  },
  {
    target: '.flex.flex-row.sm\\:flex-row.items-start.sm\\:items-center.gap-2',
    content: 'Gestiona la rutina: selecciona el día, sube una imagen o elimina la rutina del plan.',
    placement: 'right',
  },
  {
    target: '.addejercicio',
    content: 'Agrega nuevos ejercicios a la rutina haciendo clic aquí.',
    placement: 'bottom',
  }
];